

import React from 'react'
import styled from 'styled-components'

import useModal from '../../../hooks/bakery/useModal'
import useSell from '../../../hooks/nft/useSell'
import useAuction from '../../../hooks/nft/useAuction'
import { stopPropagation } from '../../../utils/func'

import { ButtonConfirmed } from '../../Button'
import SellComboModal from '../../../pages/Restaurant/components/SellComboModal'

const Button = styled(ButtonConfirmed)`
  border: none;
  font-size: 14px;
  width: 244px;
  height: 40px;
  border-radius: 10px;
  padding: 0;
`

export default function AuctionBtn (
  {artwork, marketType, symbol}: 
  {artwork: any, marketType: string, symbol: string}
) {
  const { onSell } = useSell(artwork.tokenId, marketType)
  const { onAuction } = useAuction(artwork.tokenId, artwork.nftType?.toString())
  const [auctionkExchange] = useModal(
    <SellComboModal
      marketType={marketType}
      onConfirm={onSell}
      tokenName={symbol}
      title="Please set the opening price"
      type="Auction"
      onAuction={onAuction}
    />,
  )

  const onPresentExchange = (event: any) => {
    stopPropagation(event)
    auctionkExchange()
  }

  return (
    <Button
      style={{
        marginRight: '16px',
        background: '#FFFDFA',
        border: '1px solid #AC562A',
        color: '#AC562A'
      }}
      onClick={(event: any) => {onPresentExchange(event)}}
    >
      Auction
    </Button>
  )
}